import { Skull, Crosshair, Scale } from "lucide-react";

export default function HowItWorks() {
  return (
    <section className="border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-12 gap-px bg-white/10">
          <div className="col-span-12 md:col-span-7 bg-[#050505] p-8 md:p-12">
            <div className="tag mb-6">01 · PROTOCOL</div>
            <h2 className="font-display font-black text-3xl md:text-5xl tracking-tighter leading-tight">
              Submit your idea.
              <br />
              We make it <span className="text-[#E5FE40]">defend itself.</span>
            </h2>
            <p className="mt-6 text-white/60 max-w-xl">
              Title. One paragraph. Target customer. Stage. Optional URL. That&apos;s all our panel
              needs to begin. No fluff. No founder narrative. Just the idea, naked.
            </p>
          </div>

          <div className="col-span-6 md:col-span-5 bg-[#0a0a0a] p-8 md:p-10">
            <Skull size={32} className="text-[#FF3333] mb-4" />
            <h3 className="font-display font-bold text-xl">5 hostile personas</h3>
            <p className="text-sm text-white/55 mt-3">
              Each one independently briefs against you. No softening. No &ldquo;but the upside is…&rdquo;
            </p>
          </div>

          <div className="col-span-6 md:col-span-3 bg-[#0a0a0a] p-8 md:p-10">
            <Crosshair size={32} className="text-[#E5FE40] mb-4" />
            <h3 className="font-display font-bold text-xl">Kill criteria</h3>
            <p className="text-sm text-white/55 mt-3">
              The exact conditions under which you should walk away — written before you start.
            </p>
          </div>

          <div className="col-span-12 md:col-span-5 bg-[#050505] p-8 md:p-10">
            <Scale size={32} className="text-[#E5FE40] mb-4" />
            <h3 className="font-display font-bold text-xl">Pivot Score 0–100</h3>
            <p className="text-sm text-white/55 mt-3">
              A single number, weighted by the panel&apos;s verdicts. Below 35 means stop. Above 70
              means run. Everything between is the work.
            </p>
          </div>

          <div className="col-span-12 md:col-span-4 bg-[#0a0a0a] p-8 md:p-10">
            <div className="tag mb-4">TRACTION CHECKLIST</div>
            <p className="font-display text-2xl leading-tight">
              Concrete experiments to validate before writing a single line of code.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
